import {makeStyles} from '@material-ui/core';

const drawerWidth = 240;

export const useStyles = makeStyles((theme) => {
  let styles = {
    root: {
      //   display: 'flex',
    },
    title: {
      flexGrow: 1,
    },
    image: {
      verticalAlign: 'middle',
      height: '36px',
    },
    logo: {
      height: 'auto',
      width: 'auto',
      maxHeight: '36px',
      marginRight: '10px',
      verticalAlign: 'middle',
      '&:hover': {
        cursor: 'pointer',
      },
    },
    buttons: {
      marginLeft: 'auto',
    },
    icon: {
      color: '#fafafa',
      fontSize: '0.8em',
    },
    appbar: {
      background: '#1C4257',
      fontSize: '1rem',
      boxShadow: '0px 0px 0px 0px',
      zIndex: theme.zIndex.modal - 1,
    },
    toolbar: {
      verticalAlign: 'middle',
      minHeight: '56px',
    },
    helper: {
      display: 'inline-block',
      height: '100%',
      verticalAlign: 'middle',
    },
    brand: {
      fontSize: '16px',
      borderLeft: '1px solid #fafafa',
      paddingLeft: '15px',
    },
    nested: {
      paddingLeft: theme.spacing(4),
    },
    drawer: {
      width: drawerWidth,
      flexShrink: 0,
      zIndex: 700 + '!important',
    },
    content: {
      flexGrow: 1,
    },
    drawerPaper: {
      width: drawerWidth,
    },
    customBadge: {
      backgroundColor: 'red',
      color: 'white',
    },
  };
  return styles;
});

export default useStyles;
